export default {
  path: '/queue',
  component: () => import('../../views/queuePage/queue-router.vue'),
  children: [
    {
      path: '',
      name: 'QueuePage',
      component: () => import('../../views/queuePage/pages/QueuePage/QueuePage.vue'),
      meta: {
        name: 'navigationDrawer.queuePage',
        icon: '/icons/queue-list.svg',
        auth: true
      }
    }
  ]
}
